export default "__VITE_ASSET__H2lq18Ll__"